import styled from 'styled-components'

export const Table = styled.table`
    border-collapse: collapse;
    border-spacing: 0;
    margin-top: 1rem;
    width: 95%;
    max-width: 800px;
    border-radius: 4px;
    margin: 4rem auto;
`

export const Head = styled.thead`
    background-color: #dfdfe2;
`

export const TH = styled.th`
    border: 1px solid #dfdfe2;
    text-align: left;
    padding: 1rem;
`

export const TD = styled.td`
    border: 1px solid #dfdfe2;
    text-align: left;
    padding: 1rem;
`